export function string_with_min_length(input: string, min_length: number = 4, char: string = '0'): string {
    return (char.repeat(min_length) + input).substr(-min_length);
}

export function string_from_hash(number: number) {
    return string_with_min_length(number.toString(16));
}